// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"c70d6088","265":"ef811e59","335":"43a02211","890":"d68a44b0"}[chunkId] + ".chunk.js";
};